/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q2_QuestionInputs */

const en_home_faq_q2_question = /** @type {(inputs: Home_Faq_Q2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does the claims process work?`)
};

const fr_home_faq_q2_question = /** @type {(inputs: Home_Faq_Q2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment fonctionne le processus de réclamation ?`)
};

/**
* | output |
* | --- |
* | "How does the claims process work?" |
*
* @param {Home_Faq_Q2_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q2_question = /** @type {((inputs?: Home_Faq_Q2_QuestionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q2_QuestionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q2_question(inputs)
	return fr_home_faq_q2_question(inputs)
});